import { useQuery } from "react-query";
import useNetworkHeaders from "../../../hooks/useNetworkHeaders";
import { getContact } from "../../../queries/contacts";
import { useMemo } from "react";

export type ContactHistoryItem = {
  id: number | string;
  sub_type: string;
  status: string;
  submitted_at: string;
} & (
  | {
      type: "CRM Request";
      display_id: string;
    }
  | {
      type: "Permit";
      formal_number: string | null;
      application_id: string;
    }
);

export const CONTACT_HISTORY_QUERY_KEY = "contactHistory" as const;
export function useContactHistory(id: number | string, enabled = true) {
  const headers = useNetworkHeaders();
  const query = useQuery([CONTACT_HISTORY_QUERY_KEY, id], () => getContact(headers)(null, `${id}`, true), {
    enabled: enabled && !!id && +id > 0,
  });
  const history = useMemo(() => query.data?.data?.attributes?.history, [query.data]) as
    | ContactHistoryItem[]
    | undefined;
  return { ...query, history };
}
